<template>
  <div class="orderDetail">
    <div class="titleWrap">
      <div class="setTitle">详情</div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/order' }">账单列表</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="explainDiv">
        月份：{{ orderTime }}，账单金额：{{ orderCount }}，缴费方式：{{ orderMode }}
      </div>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <el-table :data="orderAttr" class="list">
        <el-table-column type="index" label="序号" width="80" :index="indexMethod" :align="align"></el-table-column>
        <el-table-column prop="room" label="房间号" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="number" label="乘梯次数" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.number) }}
          </template>
        </el-table-column>
        <el-table-column prop="rate" label="所占比例" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ setInt(scope.row.rate * 100) }}%
          </template>
        </el-table-column>
        <el-table-column prop="expense" label="缴费金额" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="payStatus" label="缴费情况" min-width="180" :align="align">
          <template slot-scope="scope">
            <div class="autho open" v-if="scope.row.payStatus === 1"></div>
            <div class="autho close" v-if="scope.row.payStatus === 0"></div>
            {{ getPayStatus(scope.row.payStatus) }}
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </div>
</template>

<script>
export default {
  name: 'OrderDetail',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      villageId: '', // 小区Id
      villageName: '', // 小区名称
      orderId: '', // 账单Id
      orderTime: '', // 月份
      orderCount: '', // 账单金额
      orderMode: '', // 缴费方式
      orderAttr: [] // 账单列表
    }
  },
  mounted () {
    // 小区名称
    if (this.$store.state.user.villageId === '') {
      this.villageId = ''
      this.villageName = ''
    } else {
      this.villageId = this.$store.state.user.villageId
      this.villageName = this.$store.state.user.villageName
    }
    // 账单Id
    this.orderId = this.$route.query.id
    // 月份
    this.orderTime = this.$route.query.orderTime
    // 账单金额
    this.orderCount = this.$route.query.orderCount
    // 缴费方式
    if (this.$route.query.orderMode === '0') {
      this.orderMode = '按比例'
    } else if (this.$route.query.orderMode === '1') {
      this.orderMode = '按次数'
    } else {
      this.orderMode = '-'
    }

    // 获取账单列表
    this.getOrderList()
  },
  methods: {
    getOrderList () {
      this.$http.get(this.$api.order_detail_list, {
        params: {
          orderId: this.orderId
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.orderAttr = data.data
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    search () {
      this.getOrderList()
    },
    notData (str) {
      return this.$null(str)
    },
    getPayStatus (str) {
      if (str === 0) {
        return '未缴'
      }
      if (str === 1) {
        return '已缴'
      }
    },
    setInt (str) {
      return parseInt(str)
    },
    createDate (time) {
      if (time === '' || time === null) {
        return '-'
      } else {
        return time.substr(0, 4) + '-' + time.substr(5, 2) + '-' + time.substr(8, 2) + ' ' + time.substr(11, 2) + ':' + time.substr(14, 2) + ':' + time.substr(17, 2)
      }
    },
    indexMethod (index) {
      // index从0开始
      return index + 1
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.orderDetail
  box-sizing border-box
  padding 80px 20px 60px
  width 100%
  height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .el-breadcrumb
      float left
      margin-left 20px
      height 32px
      line-height 32px
      font-size 12px
    .explainDiv
      float right
      height 32px
      line-height 32px
      font-size 14px
      color #333
  .tableWrap
    margin-top 20px
    padding-top 12px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .select
      float left
      margin-top 8px
      margin-left 20px
      width 160px
    .input
      float left
      margin-top 8px
      margin-left 20px
      width 160px
    .time
      float left
      margin-top 8px
      margin-left 20px
    .searchBtn
      float left
      margin-top 8px
      margin-left 20px
      padding 5.5px 6px
      font-size 18px
    .list
      margin-top 20px
      thead
        tr, th
          color #666
          background-color #fafafa
          .cell
              font-weight bold
      tbody
        tr, th
          color #333
      td
        padding 7px 0
      .cell
        line-height 26px
        .autho
          display inline-block
          width 10px
          height 10px
          border-radius 50%
          &.open
            background-color #60ACFC
          &.close
            background-color #ccc
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
</style>



// WEBPACK FOOTER //
// src/components/order/orderDetail.vue